<template>
  <v-container fluid class="pa-0">
    <v-btn
      fixed
      left
      fab
      small
      class="mt-3"
      @click="showStatisticsDialog = true"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-dialog
      v-model="showMapillaryDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-btn
          absolute
          right
          fab
          small
          style="top: 5px; right: 5px; z-index: 999"
          @click="showMapillaryDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div id="mly"></div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showStatisticsDialog" persistent max-width="1100">
      <v-card>
        <v-btn
          absolute
          right
          text
          small
          style="right: 0; z-index: 999"
          @click="showStatisticsDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="dialog-title justify-center"
          >NP@Mapillary 2020 - конкурс геотегованих фото природно-заповідного
          фонду України</v-card-title
        >
        <v-card-text
          >Статистика зібраних фотографій в період проведення конкурсу з
          01.05.2020 по 15.12.2020 в межах ПЗФ України:

          <v-data-table
            :items="statistics"
            :headers="headers"
            hide-default-footer
            disable-pagination
            disable-filtering
            disable-sort
            fixed-header
            height="300"
          >
            <template v-slot:[`item.name`]="{ item }">
              <span
                v-html="
                  `<a class='links' target='_blank' href='https://www.mapillary.com/app/user/${item.name}'>${item.name}</a>`
                "
              ></span>
            </template>
            <template v-slot:[`item.paname`]="{ item }">
              <span v-html="`${getPaName(item.paname)}`"></span>
            </template>
          </v-data-table>

          <p>
            <small>{{ updated }}</small>
          </p>

          <p>
            Конкурс геотегованих фотографій ПЗФ проводиться для об'єктів ПЗФ,
            які додані в проект
            <a href="https://www.openstreetmap.org/"> OpenStreetMap </a>. Якщо
            Вам відомий об'єкт ПЗФ якого немає на карті - додайте його в проект
            OpenStreetMap використовуючи теги
            <a
              href="https://wiki.openstreetmap.org/wiki/Tag:boundary%3Dprotected_area"
              >'boundary=protected_area'</a
            >,
            <a
              href="https://wiki.openstreetmap.org/wiki/Tag:boundary%3Dnational_park"
              >'boundary=national_park'</a
            >
            або напишіть на
            <a href="https://forum.openstreetmap.org/viewtopic.php?id=69268"
              >сторінці конкурсу</a
            >.
          </p>

          <p>
            Для перегляду кордонів природно-заповідного фонду України та
            покриття геотегованих фотографій
            <a href="https://www.mapillary.com/">Mapillary</a> закрийте поточне
            вікно статистики. Для перегляду зображень використовуйте кнопки
            переміщення у вікні перегляду фотографій або натисніть в будь-якому
            місці треку на карті
          </p>

          <p>
            Cторінка на сайті OpenStreetMap Wiki -
            <a
              href="https://wiki.openstreetmap.org/wiki/NP@Mapillary_2020#.D0.A3.D0.BC.D0.BE.D0.B2.D0.B8"
              >link</a
            >, на форумі OpenStreetMap -
            <a href="https://forum.openstreetmap.org/viewtopic.php?id=69268"
              >link</a
            >
          </p>

          <p>
            Telegram-канал -
            <a href="https://t.me/mapillaryukraine"
              >https://t.me/mapillaryukraine</a
            >, Telegram-чат -
            <a href="https://t.me/mapillaryukrainechat"
              >https://t.me/mapillaryukrainechat</a
            >, Facebook сторінка -
            <a href="https://fb.me/mapillaryukraine"
              >https://fb.me/mapillaryukraine</a
            >
          </p>

          <div style="display: flex; justify-content: center">
            <a href="https://www.mapillary.com/" target="_blank">
              <img src="./../assets/mapillary_logo.png" alt="Mapillary" />
            </a>
            <a href="http://openstreetmap.org.ua/" target="_blank">
              <img src="./../assets/osm_logo.png" alt="OpenStreetMap" />
            </a>
            &nbsp;&nbsp;
            <a href="http://scgis.org.ua/" target="_blank">
              <img src="./../assets/scgis_logo.png" alt="Conservation GIS" />
            </a>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div id="map"></div>
  </v-container>
</template>

<script>
import axios from "axios";
import mapboxgl from "mapbox-gl";
import * as Mapillary from "mapillary-js";

export default {
  name: "MainMap",

  metaInfo: {
    title: process.env.VUE_APP_TITLE,
  },

  data() {
    return {
      updated: "",

      map: {},
      mly: {},

      showStatisticsDialog: true,
      showMapillaryDialog: false,

      headers: [
        { text: "Mapillary профіль", value: "name" },
        { text: "Об'єкти ПЗФ України", value: "paname" },
        { text: "Кількість фото", value: "count" },
      ],

      statistics: [],
    };
  },

  methods: {
    getPaName(pa) {
      let pacontent = "";
      for (let key in pa) {
        let paname = key;
        let osmid = pa[key];

        let osmtype = "way";

        if (parseInt(osmid) < 0) {
          osmtype = "relation";
          osmid = parseInt(osmid) * -1;
        }

        let paurl = `<a class='links' target="_blank" href="http://www.openstreetmap.org/${osmtype}/${osmid}">${paname}</a>, `;
        pacontent = pacontent + paurl;
      }

      return pacontent.slice(0, -2);
    },

    showMapillaryImage(image_key) {
      console.log(image_key);

      setTimeout(() => {
        if (
          Object.entries(this.mly).length === 0 &&
          this.mly.constructor === Object
        ) {
          this.mly = new Mapillary.Viewer(
            "mly",
            process.env.VUE_APP_MAPILLARY_CLIENT_ID,
            null,
            {
              component: {
                attribution: true,
                bearing: true,
                cache: false,
                cover: false,
                direction: true,
                keyboard: true,
                loading: true,
                sequence: true,
                marker: true,
                imagePlane: {
                  imageTiling: true,
                },
              },
            }
          );

          this.mly.moveToKey(image_key).then(
            (node) => {
              console.log("node.key", node.key);
            },
            (error) => {
              console.error(error);
            }
          );

          window.addEventListener("resize", () => {
            this.mly.resize();
          });
        } else {
          this.mly.moveToKey(image_key).then(
            (node) => {
              console.log("node.key", node.key);
            },
            (error) => {
              console.error(error);
            }
          );
          console.log("mly map available");
        }
      }, 700);
    },
  },

  mounted() {
    this.$gtag.pageview({
      page_path: "/",
    });

    mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
    const map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/spatialhast/ck9tkk6m20fur1imprgfxj36c",
      center: [31.198, 48.642],
      zoom: 6.0,
      hash: true,
    });

    map.addControl(new mapboxgl.ScaleControl(), "bottom-right");
    map.addControl(new mapboxgl.NavigationControl(), "top-right");

    map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
        showAccuracyCircle: false,
      }),
      "top-right"
    );

    map.on("load", () => {
      // map.addSource("photo_point", {
      //   type: "geojson",
      //   data: "photo_point.geojson",
      // });

      // map.addLayer({
      //   id: "photo_point",
      //   type: "circle",
      //   source: "photo_point",
      //   layout: {},
      //   paint: {
      //     "circle-radius": {
      //       base: 1,
      //       stops: [
      //         [10, 1],
      //         [15, 2],
      //         [17, 5],
      //       ],
      //     },
      //     "circle-color": "#345b37",
      //     "circle-stroke-width": {
      //       base: 1,
      //       stops: [
      //         [15, 0],
      //         [16, 1],
      //       ],
      //     },
      //     "circle-stroke-color": "hsl(0, 0%, 98%)",
      //   },
      // });

      map.on("click", "np-mapillary-photo-point-2020s", (e) => {
        let key = e.features[0].properties.key;
        this.showMapillaryDialog = true;
        this.showMapillaryImage(key);
        console.log(key);
      });

      let popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      });

      map.on("mouseenter", "np-mapillary-photo-point-2020s", function (e) {
        map.getCanvas().style.cursor = "pointer";

        let coordinates = e.features[0].geometry.coordinates.slice();
        let username = e.features[0].properties.username;

        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        popup.setLngLat(coordinates).setHTML(username).addTo(map);
      });

      map.on("mouseleave", "np-mapillary-photo-point-2020s", function () {
        map.getCanvas().style.cursor = "";
        popup.remove();
      });
    });

    this.map = map;

    axios({
      method: "get",
      url: `mapillary_data.json?timestamp=${new Date().getTime()}`,
    })
      .then(
        (response) => {
          this.statistics = response.data;
        },
        (error) => {
          console.log("error", error);
          throw error;
        }
      )
      .catch((error) => {
        console.log("cerror", error);
        throw error;
      });

    axios({
      method: "get",
      url: `upd.json?timestamp=${new Date().getTime()}`,
    })
      .then(
        (response) => {
          this.updated = response.data;
        },
        (error) => {
          console.log("error", error);
          throw error;
        }
      )
      .catch((error) => {
        console.log("cerror", error);
        throw error;
      });
  },
};
</script>
